function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cirkel_svg__st0{fill:none;stroke:currentColor;stroke-width:3px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cirkel_svg__st0",
  d: "M4.9 4.9h54.3v54.3H4.9z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cirkel_svg__st0",
  cx: 32,
  cy: 32,
  r: 16.6
});

function SvgCirkel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cirkel_svg__Layer_1",
    viewBox: "4 4 56 56"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iNCA0IDU2IDU2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLnN0MCB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6IGN1cnJlbnRDb2xvcjsKICAgICAgICBzdHJva2Utd2lkdGg6IDNweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9InN0MCIgeD0iNC45IiB5PSI0LjkiIHdpZHRoPSI1NC4zIiBoZWlnaHQ9IjU0LjMiLz4KICA8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIzMiIgY3k9IjMyIiByPSIxNi42Ii8+Cjwvc3ZnPg==";
export { SvgCirkel as ReactComponent };